import { useEffect } from "react";

// Apply RTL to document
export const useRTLDocument = (isRTL, language) => {
  useEffect(() => {
    document.documentElement.dir = isRTL ? "rtl" : "ltr";
    document.documentElement.lang = language;
  }, [isRTL, language]);
};
